export default __webpack_public_path__ + "static/media/student-profile.be892b10.png";